<template>
  <div class="job-banner">
    <div class="job-banner__title">
      {{ banner.title }}
    </div>
    <Button v-bind:url="banner.url" button-class="job-banner__button">
      {{ banner.button }}
    </Button>
  </div>
</template>

<script>
import Button from '@/components/Button';

export default {
  name: 'JobBanner',
  components: {
    Button,
  },
  props: {
    banner: Object,
  }
};
</script>

<style lang="scss">
@import '@/styles/functions.scss';

  .job-banner {
    color: white;

    &__title {
      text-align: center;
      font-family: 'Zilla Slab', sans-serif;
      font-weight: bold;
      font-size: 24px;
      line-height: 29px;
      margin-bottom: 24px;
    }

    &__button {
      max-width: 247px;
      width: 100%;
      margin: 0 auto;
    }

    @include media-breakpoint-up(md) {
      &__title {
        font-size: 28px;
        line-height: 34px;
        text-align: left;
      }

      &__button {
        margin: 0;
      }
    }

    @include media-breakpoint-up(lg) {
      max-width: 949px;
      margin: 0 auto;

      &__title {
        font-size: 32px;
        line-height: 38px;
      }
    }
  }
</style>
